<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-title>Lion</ion-title>
        <ion-buttons slot="start" @click="close" style="padding-left: 10px">
          <ion-icon
            icon="arrow-back-outline"
            size="large"
            color="medium"
          ></ion-icon>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen>
      <div class="image-zoom-container app-bg">
        <!-- this doesn't have to be an image -->
        <img id="torotate" v-lazy="imageToView" />
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
export default {
  ionViewDidEnter() {},
  ionViewDidLeave() {},
  ionViewWillEnter() {},
  ionViewWillLeave() {
    this.$store.dispatch('app/imageToView', '/img/loader/image_loader.png')
  },
  emits: ['close'],
  props: {
    imagep: { type: String, default: '/img/loader/image_loader.png' }
  },
  data() {
    return {
      image: '',
      slideOpts1: {
        zoom: {
          maxRatio: 1
        }
      },
      zm: null
    }
  },
  computed: {
    imageToView() {
      return this.$store.getters['app/imageToView']
    }
  },
  mounted() {
    let zoom = require('zoom-it')
    let wnd = window
    let elem = document.getElementById('torotate')
    this.zm = new zoom.Zoom(
      elem,
      {
        pan: true,
        rotate: false
      },
      wnd
    )
  },
  methods: {
    close() {
      //this.$emitter.emit('zoom-image')
      this.$router.go(-1)
    }
  },
  beforeUnmount() {
    this.zm = null
  }
}
</script>
<style scoped>
.image-zoom-container {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  text-align: center;
}
</style>
